import { FormChecklistAnswer, FormChecklistItem, FormSection } from './types';
import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';

function copyChecklistAnswer(answer: FormChecklistAnswer): FormChecklistAnswer {
  const base = {
    _id: answer._id,
    uniqueKeyId: answer.uniqueKeyId,
    label: answer.label,
    isRequired: answer.isRequired,
  };

  switch (answer.type) {
    case AnswerType.Compliance:
      return {
        ...base,
        type: AnswerType.Compliance,
        optionLabels: answer.optionLabels.map((ol) => ({
          option: ol.option,
          label: ol.label,
        })),
      };
    case AnswerType.Numeric:
      return {
        ...base,
        type: AnswerType.Numeric,
        unit: answer.unit,
        normMin: answer.normMin,
        normMax: answer.normMax,
        rangeMin: answer.rangeMin,
        rangeMax: answer.rangeMax,
        step: answer.step,
      };
    case AnswerType.Text:
      return {
        ...base,
        type: AnswerType.Text,
      };
    case AnswerType.OptionSelection:
      return {
        ...base,
        type: AnswerType.OptionSelection,
        options: answer.options.map((opt) => ({
          _id: opt._id,
          label: opt.label,
        })),
        isMultiselect: answer.isMultiselect,
      };
  }
}

export function copyChecklistItemValues(
  list: FormChecklistItem[]
): FormChecklistItem[] {
  return list.map((item) => {
    return {
      _id: item._id,
      uniqueKeyId: item.uniqueKeyId,
      summary: item.summary,
      description: item.description,
      parentSectionId: item.parentSectionId,
      order: item.order,
      answers: (item.answers || []).map(copyChecklistAnswer),
      errors: {
        summary: item.errors.summary,
        description: item.errors.description,
        answers: item.errors.answers,
      },
      graphicUploader: item.graphicUploader,
    };
  });
}

export function copySectionValues(
  list: FormSection[]
): FormSection[] {
  return list.map((section) => {
    return {
      _id: section._id,
      uniqueKeyId: section.uniqueKeyId,
      title: section.title,
      description: section.description,
      parentSectionId: section.parentSectionId,
      order: section.order,
      errors: {
        title: section.errors.title,
        description: section.errors.description,
      },
      graphicUploader: section.graphicUploader,
    };
  });
}

export function canPublishInspectionTemplate(
  checklistItems: readonly unknown[]
): boolean {
  return checklistItems.length > 0;
}